import { useState, useEffect } from 'react';
import {
  getDashboardStat
} from '../services/DashboardService';
import useAlert from '../../../shared/hooks/useAlert';

export const useDashboard = () => {

  const [dashboardStat, setDashboardStat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { alert, showAlert } = useAlert();

  const fetchDashboardStat = async () => {
    try {
      setLoading(true);
      const response = await getDashboardStat();
      setDashboardStat(response.data);

      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }

    setLoading(false);
  };


  useEffect(() => {
    fetchDashboardStat();
  }, []);

  return {
    loading,
    error,
    alert,
    dashboardStat,
  };

};
